import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.9 6.8 9.8 8.9V7.4H7.4V6.2h2.4V4.7zM6.2 7.1 4.1 9.2l2.1 2.1V9.8h2.4V8.6H6.2z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.231 4.359a6 6 0 0 0-.494 6.523l-.71 2.337a.6.6 0 0 0 .748.748l2.333-.71a6 6 0 1 0-1.877-8.898m2.345-.503a4.8 4.8 0 1 1-.078 8.24.6.6 0 0 0-.488-.063l-1.509.46.46-1.511a.6.6 0 0 0-.061-.487 4.8 4.8 0 0 1 1.676-6.64",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }